import { message, } from "../message";
export const query = message;
